import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { SummaryApi } from '../api/summary.api';
import { switchMap, map } from 'rxjs/operators';
import { SummaryData, SummaryMst, PatientSummary } from '../../../interfaces/patient-services/summary';

@Injectable()
export class SummaryService extends SummaryData {

  constructor(private api: SummaryApi) {
    super();
  }


  list(url: string): Observable<any[]> {
    return this.api.list(url);
  }

  get_patient_summary(url: string): Observable<any[]> {
    return this.api.get_patient_summary(url);
  }

  getById(url:string): Observable<SummaryMst>{
      return this.api.getById(url);
  }

  create(url: string, data:any): Observable<SummaryMst> {
    return this.api.add(url,data);
  }

 

  update(url: string, data:SummaryMst): Observable<SummaryMst> {
    return this.api.update(url,data);
  }

  update_patient_summary(url: string, data:any): Observable<any> {
    return this.api.update_patient_summary(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }

  delete_summary(url: string): Observable<boolean> {
    return this.api.delete_summary(url);
  }

  
}
